import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { APP_STORE_URL, PLAY_STORE_URL } from '../site/appLinks';

export const DownloadRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(userAgent)) {
      window.location.href = PLAY_STORE_URL;
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      window.location.href = APP_STORE_URL;
    } else {
      // For desktop fallback — go to download page or show QR code
      navigate('/download');
    }
  }, [navigate]);

  return (
    <div style={{ color: 'white', textAlign: 'center', marginTop: '100px' }}>
      Redirecting to the right store...
    </div>
  );
};
